import Tooltip from "@material-ui/core/Tooltip";
import React, { useState } from "react";
import { BiChevronRight, BiInfoCircle } from "react-icons/bi";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import "../../../../style/MyAccount-ticket/universal-line-ticket.scss";
import { HiOutlineTicket, HiQrcode } from "react-icons/hi";
import format from "date-fns/format";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import SingleExercise from "./singleExercise";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import SelectPassBar from "./selectPassBar";
import SelectPassModalFooter from "./selectPassModalFooter";
import { useTranslation } from "react-i18next";
import HtmlTooltip from "@mui/material/Tooltip";

interface IProps {
  ticket: Ticket;
  getSelect: () => void;
}
const SelectPassDesktop: React.FC<IProps> = ({ ticket, getSelect }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );

  return (
    <React.Fragment>
      {ticket.passtype === 2 && ticket.ticket === false && (
        <div className="line-horizontal flex-between-center">
          <div className="flex-start-center">
            <HiOutlineTicket className="big-icon" />

            <div className="line-horizontal-text">
              <h3 className="flex-start-center">
                {ticket.name}



                <HtmlTooltip
            placement="right"
            title={
              <React.Fragment>
                <article
                  className="tooltip-description"
                  dangerouslySetInnerHTML={{ __html: ticket.description }}
                ></article>
              </React.Fragment>
            }
          >
            <b>
              <BiInfoCircle className="tooltip-icon" />
            </b>
          </HtmlTooltip>

         
              </h3>
              <span>
                {t("wazny_od")}: <b>{format(ticket.validfrom, "dd.MM.yyyy")}r.</b> {t("do")}:{" "}
                <b>{format(ticket.validto, "dd.MM.yyyy")}</b>
              </span>
            </div>
          </div>
          <div className="line-horizontal-buttons">
            <button
              onClick={() => setAssignedList(!open)}
              className="button padding-medium medium button-fill-background-main full-button"
            >
              {t("pokaz_terminy")}
            </button>

            <button
              onClick={() => setOpen(!open)}
              className="button padding-medium medium button-fill-main full-button"
            >
              {t("pokaz_kod_qr")}
              <HiQrcode className="icon" />
            </button>
          </div>
        </div>
      )}

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <button
            onClick={() => setOpen(!open)}
            className="button big padding-medium button-fill-second  center-button"
          >
            {t("gotowe_schowaj")}
          </button>
        </ModalComponent>
      )}

      {assignedList && (
        <ModalComponent
          footer={false}
          open={assignedList}
          closeModal={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          onAccept={() => setAssignedList(false)}
        >
          <React.Fragment>
            <SelectPassBar ticket={ticket} />

         
              {ticket.exercises[0] && (
                <div>
                  {ticket.exercises.map((exercise, index) => (
                    <div key={index}>
                      <SingleExercise exercise={exercise} getSelect={getSelect}  />
                    </div>
                  ))}
                </div>
              )}
       
            {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
          </React.Fragment>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default SelectPassDesktop;
